module.exports = __webpack_public_path__ + "img/lightbulb.631a5712.svg";